export default __webpack_public_path__ + "static/media/pavel_l.837f0ffe.jpg";